<div class="btn-group">
  <input type="file" (change)="select(input)" #input hidden />
  <button class="btn btn-{{ props.btnClass }}" (click)="input.click()">
    <i class="{{ props.iconClass }}"></i> {{ props.text }}
  </button>
  @if (props.dropDown) {
    <div class="btn-group" ngbDropdown>
      <button class="btn btn-{{ props.btnClass }} dropdown-toggle-split" ngbDropdownToggle></button>
      <div class="dropdown-menu dropdown-menu-right" ngbDropdownMenu>
        <button class="btn" (click)="dropDown()" ngbDropdownItem>
          <i class="{{ props.dropDownIconClass }}"></i> {{ props.dropDownText }}
        </button>
      </div>
    </div>
  }
</div>
